import classNames from 'classnames';
import createDecorator from 'final-form-focus';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { createPortal } from 'react-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
import FormField from '@ui/formfield/FormField';
import formutils from '@utils/formutils';
import api from '@utils/api';
import ErrorBox from '@components/common/ErrorBox';
import { siteUrl } from '@common/utils/urlutils';
import analytics from '@stone/utils/analytics';
import Icon from '@stone/ui/icon/Icon';
import Button from '@stone/ui/button/Button';
import ProfileNameFields from '@stone/components/account/ProfileNameFields';
import LoginOrRegisterSocial from '@stone/components/login/LoginOrRegisterSocial';
import NewsletterSection from '@stone/components/account/NewsletterSection';
import { getRandomUUID } from '@common/utils/stringUtils';
import SubmitButton from '@stone/ui/button/SubmitButton';
const focusOnError = createDecorator(); // must be outside the component
const RegisterForm = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [requiredMarketingConsent, setRequiredMarketingConsent] = useState([]);
    const registerFormRef = useRef(null);
    const [linkCopied, setLinkCopied] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [linkRegister, setLinkRegister] = useState();
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).registerButton;
    const params = new URLSearchParams(window.location.search);
    useEffect(() => {
        let val = {};
        api.getForm('profile', val).then((data) => {
            if (!props.app) {
                //  mandatory on FE
                // data.day.mandatory = true;
                // data.month.mandatory = true;
                // data.year.mandatory = true;
                val.webVer = '12.0';
                val.useSingleField = 'true';
                data.dateofbirthfull.mandatory = true;
                data.personalinforadio.mandatory = true;
                data.trackingbrowsingradio.mandatory = true;
            }
            if (params.get('orderNumber')) {
                api
                    .getOrderDetail(params.get('orderNumber'), params.get('token'))
                    .then((orderData) => {
                    //@ts-ignore
                    const shippingAddress = (orderData === null || orderData === void 0 ? void 0 : orderData.shipping.length) ? orderData === null || orderData === void 0 ? void 0 : orderData.shipping[0].shippingAddress : {};
                    val.title = shippingAddress.title;
                    val.firstname = shippingAddress.firstName;
                    val.lastname = shippingAddress.lastName;
                    val.phone = shippingAddress.phone;
                    val.email = orderData === null || orderData === void 0 ? void 0 : orderData.orderEmail;
                    val.phonePrefix = shippingAddress.phonePrefix;
                    setInitialValues(val);
                    setFormdef(data);
                })
                    .catch(() => {
                    setInitialValues(val);
                    setFormdef(data);
                });
            }
            else if (window.customerData && window.customerEmail) {
                api
                    .CustomerExistByEmail(props.loginEmail)
                    .then((customer) => {
                    val.title = customer.title;
                    val.email = customer.email;
                    val.firstname = customer.firstName;
                    val.lastname = customer.lastName;
                    val.phone = customer.phone;
                    val.phonePrefix = customer.phonePrefix;
                    val.title = customer === null || customer === void 0 ? void 0 : customer.title;
                    //Valorizzo il field Date-Birthday e metto lo 0 davanti a quelli < 9
                    let monthRight = Number(customer.month + 1);
                    let month = monthRight.toString().padStart(2, '0');
                    let day = customer.day.toString().padStart(2, '0');
                    val.localname = customer === null || customer === void 0 ? void 0 : customer.localName;
                    val.localsurname = customer === null || customer === void 0 ? void 0 : customer.localSurname;
                    (customer === null || customer === void 0 ? void 0 : customer.gender) &&
                        data.gender.options.forEach((gender) => {
                            if ((customer === null || customer === void 0 ? void 0 : customer.gender) === gender.label) {
                                val.gender = gender.htmlValue;
                            }
                        });
                    val.dateofbirthfull = customer.year + '-' + month + '-' + day;
                    setInitialValues(val);
                    setFormdef(data);
                })
                    .catch(() => {
                    setInitialValues(val);
                    setFormdef(data);
                });
            }
            else {
                if (params.get('email')) {
                    val.email = params.get('email');
                }
                if (props.loginEmail) {
                    val.email = props.loginEmail;
                }
                if (props.firstName && props.lastName && props.inContactUs) {
                    val.firstname = props.firstName;
                    val.lastname = props.lastName;
                    val.phone = props.phone;
                    val.phonePrefix = props.phonePrefix;
                    if (props.localName && props.localSurname) {
                        val.localname = props.localName;
                        val.localsurname = props.localSurname;
                    }
                }
                setInitialValues(val);
                setFormdef(data);
            }
        });
    }, []);
    const onSubmit = async (values) => {
        setErrors([]);
        if (window.clickfromstore) {
            values.isClickFromStore = 'clickFromStore';
            if (emailSent) {
                values.sendEmail = true;
            }
        }
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        if (values.personalinforadio && ['US'].includes(window.country)) {
            if (!values.smsChannel && !values.emailChannel && !values.letterChannel && !values.phoneChannel) {
                setRequiredMarketingConsent([t('error.consentmarketing')]);
                let inputMarketing = document.querySelector('.marketing-radio');
                inputMarketing.focus();
                return;
            }
        }
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        if (params.get('destination')) {
            values.destination = params.get('destination');
        }
        let newsletterSelection = '';
        if (values.personalinfo) {
            if (values.addtoemaillistchildren) {
                newsletterSelection += newsletterSelection != '' ? '_children' : 'children';
            }
            if (values.addtoemaillistmen) {
                newsletterSelection += newsletterSelection != '' ? '_men' : 'men';
            }
            if (values.addtoemaillistwomen) {
                newsletterSelection += newsletterSelection != '' ? '_women' : 'women';
            }
            if (values.addtoemaillistgrenoble) {
                newsletterSelection += newsletterSelection != '' ? '_grenoble' : 'grenoble';
            }
            if (values.addtoemaillistgenius) {
                newsletterSelection += newsletterSelection != '' ? '_genius' : 'genius';
            }
        }
        const redirectAfterSuccess = new URLSearchParams(window.location.search).get('redirectToPdp');
        if (window.clickfromstore && !linkRegister) {
            return api
                .loginOnBehalfRegistration(values, formdef)
                .then((data) => {
                if (data.error) {
                    if (data.error.length > 0) {
                        setErrors(data.error);
                    }
                    else {
                        setErrors([data.message]);
                    }
                }
                if (!formutils.checkValidationAfterSubmit(data, errors)) {
                    return errors;
                }
                if (data.success) {
                    setLinkRegister(data.subscriptionLink);
                    analytics.loginOrRegister(initialValues.authenticationProviderID || 'email', 'registered');
                    if (linkCopied) {
                        if (data.subscriptionLink) {
                            navigator.clipboard.writeText(data.subscriptionLink);
                        }
                    }
                }
            })
                .catch((e) => setErrors([e]));
        }
        else {
            return api
                .register(values, formdef, redirectAfterSuccess)
                .then((data) => {
                if (data.error) {
                    if (data.error.length > 0) {
                        setErrors(data.error);
                    }
                    else {
                        setErrors([data.message]);
                    }
                }
                if (!formutils.checkValidationAfterSubmit(data, errors)) {
                    return errors;
                }
                if (data.success) {
                    analytics.loginOrRegister(initialValues.authenticationProviderID || 'email', 'registered');
                    if (props.fromPage || props.inContactUs) {
                        window.location.replace(data.redirectUrl);
                    }
                    else {
                        props.setLoginStep('registration-successful');
                        props.setForceReload(true);
                    }
                }
            })
                .catch((e) => setErrors([e]));
        }
    };
    const validate = async (values) => {
        var _a, _b;
        if (window.customerData && window.customerEmail && window.profiletoken) {
            values.profiletoken = window.profiletoken;
        }
        if (!values.dateofbirthfull) {
            let isBadInput = (_b = (_a = document.getElementById(`dateofbirthfull_${randomSuffix}`)) === null || _a === void 0 ? void 0 : _a.validity) === null || _b === void 0 ? void 0 : _b.badInput;
            if (isBadInput) {
                values.dateofbirthfull = '0000-00-00T00:00:00';
            }
        }
        return await formutils.validateForm(values, formdef, 'profile');
    };
    const turnOnOrOffChannels = (value, mutator) => {
        mutator({
            smsChannel: value,
            emailChannel: value,
            phoneChannel: value,
            letterChannel: value,
        });
    };
    // const appleSigninRegister = (values: models.RegisterForm) => {
    //   setInitialValues(values);
    // };
    const readOnlyEmail = !!(initialValues === null || initialValues === void 0 ? void 0 : initialValues.authenticationProviderID) || Boolean(props.loginEmail);
    const randomSuffix = getRandomUUID();
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: classNames('register_form', `register_form--${props.componentContext != 'page' ? 'included' : 'page'}`, { 'register-click-from-store': window.clickfromstore }) },
        !props.hideHeader && (React.createElement("div", { className: "row register_form__header" }, !window.clickfromstore && initialValues.authenticationProviderID ? (React.createElement("div", { className: "col-24" },
            React.createElement("p", { className: "register_form__subtitle" }, t('register.completesocial')))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames('col-24', { 'col-lg-20': props.componentContext !== 'page', 'col-lg-12': props.componentContext !== 'page' && !props.inContactUs }) },
                React.createElement("p", null, t('register.subtitle')),
                props.inContactUs && React.createElement("p", { className: "mt-40" }, t('register.fasterwithsocial'))),
            React.createElement("div", { className: "col-24" }, window.sociallogin && !window.clickfromstore && React.createElement(LoginOrRegisterSocial, { inline: true, register: true })))))),
        React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, mutators: { global: formutils.globalMutator }, decorators: [focusOnError], render: (formprops) => {
                const formState = formprops.form.getState();
                return (React.createElement("form", { ref: registerFormRef, onSubmit: formprops.handleSubmit },
                    React.createElement("div", { className: "form-section" },
                        !props.inContactUs && React.createElement("h3", { className: "form-section-title" }, t('login.logininfo')),
                        React.createElement("div", { className: "register_form__requiredlabel" },
                            React.createElement("p", null, t('label.mandatoryfields'))),
                        React.createElement("div", { className: 'register_form__email' + (props.setLoginStep && readOnlyEmail ? '-row' : '') },
                            React.createElement("div", { className: "register_form__input-column" },
                                React.createElement(DwFormField, { def: formdef, name: "email", readonly: readOnlyEmail, disabled: readOnlyEmail, autocomplete: "email", idSuffix: randomSuffix, helperText: window.clickfromstore ? t('register.clickfromstorepassword') : undefined, validTick: true })),
                            props.setLoginStep && readOnlyEmail && !window.customerData && !window.customerEmail && (React.createElement("div", { className: "register_form__edit-column" },
                                React.createElement(Button, { onClick: () => props.setLoginStep('email'), className: "button--editemail", cls: ['button--secondary'], type: 'button' }, t('login.editemail'))))),
                        !window.clickfromstore && !initialValues.authenticationProviderID && (React.createElement("div", { className: "register_form__password" },
                            React.createElement(DwFormField, { def: formdef, name: "password", type: "password", helperText: t('register.passwordcriteria'), autocomplete: "new-password", requiredLabel: !initialValues.authenticationProviderID, idSuffix: randomSuffix, showPassword: true, validTick: true })))),
                    !props.inContactUs && (React.createElement("div", { className: "form-section" },
                        React.createElement("h3", { className: "form-section-title" }, t('profile.personalinformation')),
                        React.createElement(ProfileNameFields, { idSuffix: randomSuffix, formdef: formdef, isRegisterForm: true, componentContext: props.componentContext }))),
                    React.createElement("div", { className: "form-section" },
                        React.createElement(DwFormField, { def: formdef, idSuffix: randomSuffix, name: "dateofbirthfull", type: "date", autocomplete: "date-of-brith", maxDate: "9999-12-31" })),
                    React.createElement("div", { className: "form-section" },
                        React.createElement(DwFormField, { def: formdef, idSuffix: randomSuffix, name: "gender", type: "radio", groupClassName: "form-group--gender-radio" })),
                    !props.phone && !props.phonePrefix && (React.createElement("div", { className: "form-section" },
                        React.createElement(DwFormFieldPhoneWithPrefix, { idSuffix: randomSuffix, def: formdef, uniqueLabel: t('profile.phonenumber') }))),
                    !window.clickfromstore && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "form-section" },
                            React.createElement("h3", { className: "form-section-title" }, t('login.marketingtitle')),
                            React.createElement("div", { className: "flag wrapper-flag" },
                                React.createElement(DwFormField, { def: formdef, type: "radio", name: "personalinforadio", idSuffix: randomSuffix, onChange: (e) => {
                                        // console.info(e);
                                        turnOnOrOffChannels(e.target.value == '0', formprops.form.mutators.global);
                                    }, groupClassName: "form-group--gender-radio" })),
                            formprops.values.personalinforadio == '1' && (React.createElement(React.Fragment, null,
                                React.createElement(NewsletterSection, { formdef: formdef, formInstance: formprops.form, formState: formState }),
                                ['US'].includes(window.country) && (React.createElement("div", { className: "register_form__comunication-channels" },
                                    React.createElement("p", { className: "register_form__info-label mt-24" },
                                        t('register.newsletterconditions'),
                                        " "),
                                    React.createElement(FormField, { className: "marketing-radio", idSuffix: randomSuffix, type: "checkbox", name: "allChannels", label: t('label.all'), onChange: (e) => {
                                            turnOnOrOffChannels(e.target.checked, formprops.form.mutators.global);
                                            setRequiredMarketingConsent([]);
                                        } }),
                                    React.createElement("div", { className: "channel-flags newsletter-flag" },
                                        React.createElement(DwFormField, { idSuffix: randomSuffix, def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "emailChannel", type: "checkbox" }),
                                        React.createElement(DwFormField, { idSuffix: randomSuffix, def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "smsChannel", type: "checkbox" }),
                                        React.createElement(DwFormField, { idSuffix: randomSuffix, def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "phoneChannel", type: "checkbox" }),
                                        React.createElement(DwFormField, { idSuffix: randomSuffix, def: formdef, onChange: (e) => setRequiredMarketingConsent([]), name: "letterChannel", type: "checkbox" })),
                                    React.createElement(ErrorBox, { errors: requiredMarketingConsent })))))),
                        React.createElement("div", { className: "form-section" },
                            React.createElement("h3", { className: "form-section-title" }, t('login.trackingbrowsingtitle')),
                            React.createElement("div", { className: "wrapper-flag" },
                                React.createElement(DwFormField, { def: formdef, type: "radio", name: "trackingbrowsingradio", groupClassName: "form-group--gender-radio mb-24" }))),
                        React.createElement("div", { className: "form-section" },
                            React.createElement(DwFormField, { def: formdef, type: "checkbox", name: "termsandconditions", requiredLabel: true })))),
                    React.createElement(ErrorBox, { errors: errors }),
                    React.createElement("div", { className: classNames('register_form__actions', {
                            'action--clickonstore': window.clickfromstore,
                        }) },
                        React.createElement("div", { className: "register_form__actions--confirm" }, (!window.clickfromstore && React.createElement(SubmitButton, { submitting: formprops.submitting, label: t('button.createaccount.registration'), fullWidth: true })) || (React.createElement(SubmitButton, { label: emailSent ? t('button.sentsubscriptionemail') : t('button.sendsubscriptionemail'), submitting: formprops.submitting, fullWidth: true, onClick: (e) => {
                                setEmailSent(true);
                                if (linkRegister) {
                                    api.sendLoginOnBehalfRegistrationEmail(props.loginEmail, linkRegister);
                                    e.preventDefault();
                                }
                                setTimeout(() => {
                                    setEmailSent(false);
                                }, 3000);
                            }, cls: [emailSent ? 'button--secondary' : 'button--primary'] }))),
                        (!window.clickfromstore && (React.createElement("div", { className: "register_form__actions--back" }, !props.inContactUs && (React.createElement(React.Fragment, null, props.setLoginStep ? (React.createElement(React.Fragment, null, props.componentContext != 'page' && props.componentContext != 'drawer' ? (React.createElement(Button, { onClick: () => props.setLoginStep('email'), cls: ['button--secondary'], className: "full", type: "button" }, t('button.cancel'))) : (React.createElement(Button, { onClick: () => props.setLoginStep('email'), cls: ['button--link'], type: "button" },
                            React.createElement(React.Fragment, null,
                                React.createElement(Icon, { ariaHidden: true, family: "10", name: "left-chevron" }),
                                t('forgotpassword.backtologin')))))) : (React.createElement("a", { href: siteUrl('login'), className: "button button--link" },
                            React.createElement("span", null,
                                React.createElement(Icon, { ariaHidden: true, family: "10", name: "left-chevron" }),
                                t('forgotpassword.backtologin'))))))))) || (React.createElement("div", { className: "register_form__actions--copy" },
                            React.createElement(Button, { type: "submit", className: "full", onClick: (e) => {
                                    setLinkCopied(true);
                                    if (linkRegister) {
                                        navigator.clipboard.writeText(linkRegister);
                                        e.preventDefault();
                                    }
                                    setTimeout(() => {
                                        setLinkCopied(false);
                                    }, 3000);
                                }, disabled: formprops.submitting, cls: linkCopied ? ['button--primary'] : ['button--secondary'] }, linkCopied ? t('button.copiedlink') : t('button.copylink'))))),
                    showRecaptcha && createPortal(React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }), document.body)));
            } })));
};
RegisterForm.defaultProps = {
    componentContext: 'page',
};
export default RegisterForm;
